import { render, staticRenderFns } from "./MedicalBag.vue?vue&type=template&id=1be3aaf5&"
import script from "./MedicalBag.vue?vue&type=script&lang=js&"
export * from "./MedicalBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports